/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Amateur_0_HeadingInputs */

const en_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural Ability with Proper Timing Over Tension`)
};

const es_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidad natural con timing correcto por encima de la tensión`)
};

const de_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natürliche Fähigkeit mit dem richtigen Timing über Spannung`)
};

const zh_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自然能力与正确时机，胜过紧张用力`)
};

const ar_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القدرة الطبيعية مع التوقيت السليم فوق التوتر`)
};

const fr_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité naturelle et bon timing plutôt que tension`)
};

const vi_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khả năng tự nhiên với timing đúng hơn căng`)
};

const sw_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uwezo wa asili kwa muda sahihi badala ya mkazo`)
};

const th_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสามารถตามธรรมชาติกับจังหวะที่ถูกต้อง แทนความตึงเกร็ง`)
};

const bs_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prirodna sposobnost s pravim tajmingom umjesto napetosti`)
};

const ja_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力みより、正しいタイミングで生かす生まれ持った能力`)
};

const ko_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`긴장보다 올바른 타이밍으로 살리는 타고난 능력`)
};

const pt_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilidade natural com o timing certo, sem tensão`)
};

const it_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacità naturali e tempismo giusto invece della tensione`)
};

const sv_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlig förmåga och rätt timing i stället för spänning`)
};

const nl_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natuurlijk vermogen met de juiste timing in plaats van spanning`)
};

const da_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlige evner med rigtig timing frem for spænding`)
};

const nb_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturlig evne og riktig timing fremfor spenning`)
};

const fi_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontainen kyky ja oikea ajoitus jännityksen sijaan`)
};

const pl_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naturalne zdolności i właściwy timing zamiast napięcia`)
};

const ru_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Природные способности и правильный тайминг вместо напряжения`)
};

const tr_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerilim Yerine Doğru Zamanlamayla Doğal Yetenek`)
};

const hi_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तनाव नहीं, सही टाइमिंग के साथ स्वाभाविक क्षमता`)
};

const id_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemampuan Alami dengan Timing yang Tepat, Bukan Ketegangan`)
};

const ms_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebolehan Semula Jadi dengan Pemasaan yang Betul, Bukan Ketegangan`)
};

const cs_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přirozené schopnosti a správné načasování místo napětí`)
};

const el_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Φυσική ικανότητα με σωστό χρονισμό αντί για ένταση`)
};

const he_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יכולת טבעית ותזמון נכון במקום מתח`)
};

const af_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natuurlike vermoë met regte tydsberekening bo spanning`)
};

const hu_method_content_step_05_detail_amateur_0_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Természetes képesség helyes időzítéssel, feszültség helyett`)
};

/**
* | output |
* | --- |
* | "Natural Ability with Proper Timing Over Tension" |
*
* @param {Method_Content_Step_05_Detail_Amateur_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_amateur_0_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Amateur_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Amateur_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_amateur_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_amateur_0_heading(inputs)
	return en_method_content_step_05_detail_amateur_0_heading(inputs)
});